module.exports = __webpack_public_path__ + "img/Hopkins.f3e46fc4.png";